// the simplest context loads the whole text in memory
export class SimpleCtx {
    constructor({ text, mode }) {
        this.text = "";
        this.line = 1;
        this.column = 1;
        this.position = 0;
        this.char = "";
        this.preecededByNL = false;
        this.mode = "ris";
        this.detectedMode = "ris";
        this.peek = (number) => {
            return this.text.substring(this.position, this.position + number);
        };
        this.advance = () => {
            if (this.isEof())
                throw new Error("Cannot advance reached end of file.");
            this.position++;
            this.char = this.text[this.position];
            if (this.preecededByNL) {
                this.preecededByNL = false;
                this.line += 1;
                this.column = 0;
            }
            this.column += 1;
            if (this.char === '\n')
                this.preecededByNL = true;
            return this.char;
        };
        this.isEof = () => this.position >= this.text.length;
        this.text = text;
        this.char = this.text[0];
        if (mode)
            this.mode = mode;
    }
}
